module.exports = __webpack_public_path__ + "img/hot-tub.b9879b1a.svg";